import React from "react";
import { useLocalization } from "@fluent/react";
import { IconButton, Table } from "@narmi/design_system";
import { SORT } from "byzantine/src/OrganizationUserList";
import type OrganizationUser from "byzantine/src/OrganizationUser";

import OrganizationUserRow from "./OrganizationUserRow";
import OrganizationUserMobileRow from "./OrganizationUserMobileRow";
import type { SortFunction } from "./OrganizationUsers.types";

interface OrganizationUsersTableProps {
  displayOrganizationUsers: OrganizationUser[];
  sortOrder: SortFunction;
  setSortOrder: (updater: (prev: SortFunction) => SortFunction) => void;
  determineSortIcon: (sortType: string, sortOrder: SortFunction) => string;
  organizationUsers?: OrganizationUser[];
  onRowClick: (user: OrganizationUser) => void;
}

const OrganizationUsersTable: React.FC<OrganizationUsersTableProps> = (
  props
) => {
  const { l10n } = useLocalization();

  return (
    <div>
      <div className="mobile-hidden">
        <Table
          kind="editable"
          colVisibility={["*", "*", "*", "*"]}
          colLayout={{
            s: "1fr 1fr 1fr 1fr",
            m: "25% 25% 25% 25%",
            l: "25% 35% 25% 15%",
          }}
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell {...({ suffixIcon: "arrow-up-down" } as any)}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {l10n.getString("org-user-column-name")}
                  <div style={{ marginLeft: "8px" }}>
                    <IconButton
                      name={
                        props.determineSortIcon("name", props.sortOrder) as any
                      }
                      onClick={() =>
                        props.setSortOrder(() =>
                          props.sortOrder === SORT.NAME_ASC
                            ? SORT.NAME_DESC
                            : SORT.NAME_ASC
                        )
                      }
                    />
                  </div>
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell>
                {l10n.getString("org-user-column-role")}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {l10n.getString("org-user-column-status")}
              </Table.HeaderCell>
              <Table.HeaderCell {...({ suffixIcon: "arrow-up-down" } as any)}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {l10n.getString("org-user-column-last-login")}
                  <div style={{ marginLeft: "8px" }}>
                    <IconButton
                      name={
                        props.determineSortIcon(
                          "lastlogin",
                          props.sortOrder
                        ) as any
                      }
                      onClick={() =>
                        props.setSortOrder(() =>
                          props.sortOrder === SORT.LASTLOGIN_ASC
                            ? SORT.LASTLOGIN_DESC
                            : SORT.LASTLOGIN_ASC
                        )
                      }
                    />
                  </div>
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {props.displayOrganizationUsers.map((member) => (
              <OrganizationUserRow
                key={member.uuid}
                member={member}
                onRowClick={props.onRowClick}
              />
            ))}
          </Table.Body>
        </Table>
      </div>
      <div className="mobile-only">
        {props.displayOrganizationUsers.map((member) => (
          <OrganizationUserMobileRow
            key={member.uuid}
            member={member}
            onRowClick={props.onRowClick}
          />
        ))}
      </div>
    </div>
  );
};

export default OrganizationUsersTable;
